import { createActionCreator } from '../utils/helpers';

import { inviteRequest, inviteSignUp, rejectInvite, inviteHashSignUp } from './types';

export const requestInvite = createActionCreator(inviteRequest.request, 'token');
export const requestInviteSuccess = createActionCreator(inviteRequest.success, 'response');
export const requestInviteFailure = createActionCreator(inviteRequest.failure, 'error');

export const completeInviteSignUp = createActionCreator(inviteSignUp.request, 'token', 'payload');
export const completeInviteSignUpSuccess = createActionCreator(inviteSignUp.success, 'response');
export const completeInviteSignUpFailure = createActionCreator(inviteSignUp.failure, 'error');

export const requestRejectInvite = createActionCreator(rejectInvite.request, 'token');
export const requestRejectInviteSuccess = createActionCreator(rejectInvite.success, 'response');
export const requestRejectInviteFailure = createActionCreator(rejectInvite.failure, 'error');

export const completeInviteHashSignUp = createActionCreator(
  inviteHashSignUp.request,
  'token',
  'payload',
);
